export default __webpack_public_path__ + "static/media/logo-invert.52832734.svg";